module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "aria-labelledby": "headersite01",
      "epub:type": "frontmatter",
      "id": "site"
    }
  }, [_c('header', {
    attrs: {
      "id": "headersite01"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilie0007#toc"
    }
  }, [_vm._v("Companion Website")])])]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "xii",
      "id": "pxii",
      "role": "doc-pagebreak"
    }
  }), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "xiii",
      "id": "pxiii",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Readers are encouraged to access digital materials associated with this book at "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.djangogen.com",
      "target": "_blank"
    }
  }, [_vm._v("http://www.djangogen.com")]), _vm._v(". This companion website provides supplementary images, audio, video, and links to further information.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f4f400bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-lie-0010.vue
// module id = 81
// module chunks = 0